import Nav from 'react-bootstrap/Nav';

function Navbar(){
    return(<>
    <Nav style={{ backgroundColor: "#007bff", padding: "10px" }} className="justify-content-center">
      <Nav.Item>
        <Nav.Link href="#Home"  style={{ color: "white", margin: "0 10px" }}>HOME</Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link href="#Create"  style={{ color: "white", margin: "0 10px" }}>CREATE</Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link href="#Deposit"  style={{ color: "white", margin: "0 10px" }}>DEPOSIT</Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link href="#Withdraw"  style={{ color: "white", margin: "0 10px" }}>WITHDRAW</Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link href="#Alldata"  style={{ color: "white", margin: "0 10px" }}>ALLDATA</Nav.Link>
      </Nav.Item>
    </Nav>
    </>)
}

export default Navbar;